module.exports = __webpack_public_path__ + "assets/img/kv-f30dc23c.jpg";